// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__qL8k9","colMaxWidth":"Table_colMaxWidth__aDDRy"};